// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box[data-v-78f838b1] {\n  height: 20px;\n  background: #f5f5f5;\n}", ""]);
// Exports
module.exports = exports;
